import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { 
  FaPhoneAlt,
  FaClipboardCheck,
  FaCogs,
  FaLightbulb, 
  FaUserShield,
  FaUsers,
  FaSmileBeam,
  FaHardHat 
} from "react-icons/fa";

import { motion } from "framer-motion";
import {
  FaIndustry,
  FaShip,
  FaTrain,
  FaBullseye,
  FaEye,
  FaCheckCircle,
  FaCertificate,
  FaUserTie,
  FaAward,
} from "react-icons/fa";
import "./About.css";
import finalBanner from "../assets/finalbanner.png";
import homebanner  from "../assets/home-page.jpg";

const Counter = ({ end }) => {
  const [count, setCount] = useState(0);
  useEffect(() => {
    let start = 0;
    const duration = 2000;
    const step = end / (duration / 30);
    const timer = setInterval(() => {
      start += step;
      if (start >= end) {
        setCount(end);
        clearInterval(timer);
      } else {
        setCount(Math.floor(start));
      }
    }, 30);
    return () => clearInterval(timer);
  }, [end]);
  return <span>{count}+</span>;
};

const About = () => {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("reveal-visible");
          }
        });
      },
      { threshold: 0.1 }
    );
    document.querySelectorAll(".reveal-on-scroll").forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);
   const values = [
    { icon: <FaPhoneAlt />, title: "Customer Delight" },
    { icon: <FaClipboardCheck />, title: "Execution of Commitments" },
    { icon: <FaCogs />, title: "Distinctive Quality" },
    { icon: <FaLightbulb />, title: "Creativity & Innovation" },
    { icon: <FaUserShield />, title: "Character" },
    { icon: <FaUsers />, title: "Teamwork" },
    { icon: <FaSmileBeam />, title: "Positive Attitude" },
    { icon: <FaHardHat />, title: "Safety First" },
  ];

  return (
    <div className="about-page">
      {/* HERO */}
<section
  className="hud-hero"
  style={{
    backgroundImage: `
      linear-gradient(
        to bottom,
        rgba(143, 182, 243, 0.65),
        rgba(214, 230, 250, 0.55),
        rgba(255, 255, 255, 0.75)
      ),
      url(${finalBanner})
    `,
  }}
>
  <div className="hero-content">
    <motion.h1
      className="hero-main-title"
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.9, ease: "easeOut" }}
    >
      ABOUT US
    </motion.h1>
  </div>
</section>


      {/* OVERVIEW & HISTORY */}
      <section className="section-padding">
        <div className="container about-grid reveal-on-scroll">
          <div>
            <span className="sub-tag">Our Legacy</span>
            <h2 className="section-title">Trusted Pump Manufacturing Partner</h2>
  <p className="description-para">
  <strong>FLOWTECH PUMPS AND MOTORS</strong> (Formerly Known as Flowwell Pumps &amp; Meters – Manufactures of Transformer Oil Pumps of various Models and Duty. Company commenced manufacturing operations in Aug. 1993), started Manufacturing Traction &amp; Non-Traction Transformer Oil Pumps, Sealless Canned Motor Pumps, Marine Centrifugal Pumps, Self-Priming Monoblock Pumps, Process Pumps under the Brand name of <strong>FLOWWELL</strong> with effective from April 2017.
</p>

<p className="description-para">
  These are offered in both Centrifugal, Axial Flow and Centrifugal Inline design suitable to meet Distribution Power Transformer up to <strong>765KV</strong>, Generating Transformers, EMU, Locomotive Transformers, Furnace &amp; Rectifier Transformer Cooling Circuit, Process Industry.
</p>

<p className="description-para">
  The pumps are manufactured with state of the art technology and we have all the requisite facilities, equipment to ensure that the pump delivered is of the highest possible level of quality, guaranteeing reliability and longer life.
</p>


            
          </div>

<div className="about-image-wrap">
  <div className="about-badge">
    <span>33+</span>
    <p>Years of Engineering Mastery</p>
  </div>

  <img
    className="about-image"
    src={homebanner}
    alt="Flowtech Factory"
  />
</div>




        </div>
 
      </section>
<div className="mv-card mv-split-layout">

  {/* LEFT SIDE */}
  <div className="mv-left">
    <p className="about-quality-text">
      Flowtech Pumps and Motors are manufacturers, Exporters and Supplier of
      Centrifugal Pump as per DIN 24256 ISO 2858, ISO 2850, ANSI B 73.1,
      ANSI B 73.3, API 685, IS 325. Our products meets the specification
      requirement of IEC 34-1, EN 51216, IEC 349-2.
    </p>

    <p className="about-quality-text">
      Based on the customer requirements, may contact our office for other
      specific and special Requirements.
    </p>
  </div>

  {/* RIGHT SIDE */}
  <div className="mv-right">
    <p className="about-quality-text">
      Flowtech is specialized in implementation of latest design by consulting
      the technological Institutions like Indian Institute of Science &
      Indian Institute of Technology. Glandless design & Construction is a
      specialty of Flowtech. We at Flowtech meet the customers demand in
      Glandless application requirements.
    </p>
  </div>

</div>

      {/* LEADERSHIP SECTION */}
     <div className="ceo-content">
  <span className="sub-tag">Leadership</span>

  <h2 className="section-title">
    Mr. S Shankar{" "}
    <small style={{ fontSize: "0.5em", color: "var(--theme-blue)" }}>
      CEO
    </small>
  </h2>

<p className="description-para">
  <strong>Mr. S SHANKAR, CEO</strong>, with <strong>33 Years’ Experience</strong> 
  (<strong>25 Years</strong> – as a <strong>Co-founder in Flowwell Pumps & Meters</strong>, 
  Looked after <strong>Entire Manufacturing Activities</strong> & Earlier to that 
  <strong>7 Years</strong> – worked for <strong>Best & Crompton Engineering Ltd</strong>, 
  Chennai & Bangalore). During <strong>25 Years tenure at Flowwell</strong> – 
  <strong>Mr S SHANKAR</strong>, contributed his service and obtained 
  <strong>Approval from Major customers</strong> – 
  <strong>BHEL, ABB, ALSTOM, PGCIL, NTPC, NPCIL</strong>, 
  <strong>INDIAN RAILWAYS (ICF, RCF, CLW)</strong> & 
  <strong>INDIAN NAVY</strong> for 
  
  <strong>SEA WATER APPLICATION PUMPS</strong>.
</p>




  <div className="award-grid">
    <div className="award-item">
      <FaAward className="award-icon" />
      <p>National Industrial Excellence Award (2007)</p>
    </div>
    <div className="award-item">
      <FaAward className="award-icon" />
      <p>Pride of India Award (2008)</p>
    </div>
  </div>
  <br/>
  <br/>

  {/* READ MORE BUTTON */}
  <Link to="/ceo-details" className="ceo-readmore-btn">
    Read More →
  </Link>
</div>


      {/* TECHNICAL SPECIALIZATION */}
 <section className="industrial-reach">
  <div className="container">
    <h2 className="section-title">Industrial Reach</h2>
    <div className="industrial-grid">
      
      {/* Item 1 */}
      <div className="industrial-card">
        <span className="card-number">01</span>
        <div className="card-header">
          <FaTrain className="card-icon" />
          <h3>Railways & Traction</h3>
        </div>
        <div className="card-body">
          <p>Approved by ICF, RCF, and CLW. Exported to ABB Geneva and Siemens Nurnberg.</p>
        </div>
        <div className="card-accent"></div>
      </div>

      {/* Item 2 */}
      <div className="industrial-card">
        <span className="card-number">02</span>
        <div className="card-header">
          <FaShip className="card-icon" />
          <h3>Marine & Defense</h3>
        </div>
        <div className="card-body">
          <p>Specialized Sea Water pumps for the Indian Navy and Defense machinery design establishments.</p>
        </div>
        <div className="card-accent"></div>
      </div>

      {/* Item 3 */}
      <div className="industrial-card">
        <span className="card-number">03</span>
        <div className="card-header">
          <FaIndustry className="card-icon" />
          <h3>Power Generation</h3>
        </div>
        <div className="card-body">
          <p>High-capacity cooling solutions for Generating Transformers up to 765KV.</p>
        </div>
        <div className="card-accent"></div>
      </div>

    </div>
  </div>
</section>
    
   


   {/* MISSION / VISION + QUALITY */}
<section className="section-padding mv-section">
  <div className="container mv-grid">
    <div className="mv-card">
      <FaBullseye className="mv-icon" />
      <h3>Our Mission</h3>
      <p>
We well be an admired company in. Traction & High Speed Trains Pump Design & Manufacturing Industry Indian & International Market.</p>
    </div>

    <div className="mv-card">
      <FaEye className="mv-icon" />
      <h3>Our Vision</h3>
      <p>We will be a high Performance company achieving Turnover of 50 Crores by 2022 through continual Improvement in Products, processes and people.</p>
    </div>

    <div className="mv-card full-width">
      <FaCheckCircle className="mv-icon" />
      <h3>Quality Commitment</h3>
      <p>
        ISO 9001:2015 Certified. Total workforce of 60+ skilled workers ensuring
        every pump meets global reliability standards.
      </p>
    </div>
  </div>
</section>
<section className="core-values-section">
  <div className="container">
    <span className="sub-tag center-tag">Our Culture</span>
    <h2 className="section-title center">Core Values</h2>
    <div className="title-underline"></div>

    <p className="center-para">
      Every Personnel of FLOWTECH is committed to upholding the following values.
    </p>

    <div className="values-modern-grid">
      {values.map((value, index) => (
        <motion.div key={index} className="value-item-card">
          <div className="value-icon-circle">{value.icon}</div>
          <h4>{value.title}</h4>
        </motion.div>
      ))}
    </div>
  </div>
</section>


    </div>
  );
};

export default About;